import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginOAuthResponse, OauthAEMConfig } from '../../../../models/login';
import { LoginRememberMeUtilsService } from '../../../../utils/login/login-remember-me-utils.service';
import {
  MFA_OAUTH_URL,
  MULTI_FACTOR_EndpointKey
} from '../../../../constants/login/login-remember-me-constant';
import { ApiBuilder, AppConfigService, handleError } from '../../../utils';
import { HttpHeadersPayload, ReplaceItem } from '../../../../models/utils';
import { HttpRequestMethods, IDP_APP } from '../../../../constants/utils';

@Injectable({
  providedIn: 'root'
})
export class LoginRedirectfulService {
  redirectfulHeader: HttpHeadersPayload = {
    'x-xsrf-header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private utils: LoginRememberMeUtilsService,
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  loginRedirectful = (
    authConfig: OauthAEMConfig,
    flowId: string
  ): Observable<LoginOAuthResponse> => {
    const getLoginRedirectfulUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowId
    ).loginOAuthRedirectfulUrl;

    const loginRedirectfulUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getLoginRedirectfulUrl
      }
    ];

    return new ApiBuilder<undefined, LoginOAuthResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(MULTI_FACTOR_EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(loginRedirectfulUrl)
      .method(HttpRequestMethods['GET'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.redirectfulHeader)
      .errorHandler(this._errorHandler)
      .library('LOGIN_REDIRECTFUL_SERVICE')
      .withCredentials(true)
      .create();
  };
}
